import * as TY from 'containers/pages/users/constants';
import validateFirstName from 'libs/validations/validateFirstName';
import validateLastName from 'libs/validations/validateLastName';
import validateEmail from 'libs/validations/validateEmail';
import {
	USER_CONFIRMPWD_ERR_MSG_MATCH,
	USER_CONTACTTYPES_ERR_MSG_EMPTY,
} from 'constants/validMsg';
import {
	USER_CUSTOMERS_ERR_MSG_EMPTY,
	USER_ROLES_ERR_MSG_EMPTY,
} from 'constants/validMsg';
import validateUsername from 'libs/validations/validateUsername';
import validatePwd from 'libs/validations/validatePwd';
import { initUser, initValid } from 'containers/pages/users/data';

/**
 * @function handleUser
 * @param {*} e
 * @param {array | undefined} payload
 * @param {User} user
 * @param {string} addressType
 * @param {function} dispatch
 * @param {function} setValid
 * @param {function} handleMode
 * @param {function} setCanNotSave
 * @returns {void}
 */
function handleUser(
	e,
	payload,
	user,
	addressType,
	dispatch,
	setValid,
	handleMode,
) {
	switch (e.target.name) {
		case TY.F_NAME:
			const _fname = validateFirstName(e.target.value);
			if (_fname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.F_NAME]: {
						isErr: true,
						errMsg: _fname.errMsg,
						canNotSave: true,
					},
				}));
			} else if (!_fname.isErr && user[TY.F_NAME] === '') {
				setValid((prev) => ({
					...prev,
					[TY.F_NAME]: { isErr: false, errMsg: '', canNotSave: true },
				}));
			} else if (!_fname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.F_NAME]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			e.target.value.length === 0 &&
				setValid((prev) => ({
					...prev,
					[TY.F_NAME]: { isErr: false, errMsg: '', canNotSave: true },
				}));
			return dispatch({ type: TY.F_NAME, payload: e.target.value });

		case TY.L_NAME:
			const _lname = validateLastName(e.target.value);
			if (_lname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.L_NAME]: {
						isErr: true,
						errMsg: _lname.errMsg,
						canNotSave: true,
					},
				}));
			} else if (!_lname.isErr && user[TY.L_NAME] === '') {
				setValid((prev) => ({
					...prev,
					[TY.L_NAME]: { isErr: false, errMsg: '', canNotSave: true },
				}));
			} else if (!_lname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.L_NAME]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			e.target.value.length === 0 &&
				setValid((prev) => ({
					...prev,
					[TY.L_NAME]: { isErr: false, errMsg: '', canNotSave: true },
				}));
			return dispatch({ type: TY.L_NAME, payload: e.target.value });

		case TY.COMPANIES:
			if (payload.length === 0) {
				setValid((prev) => ({
					...prev,
					[TY.COMPANIES]: {
						isErr: true,
						errMsg: USER_CUSTOMERS_ERR_MSG_EMPTY,
						canNotSave: true,
					},
				}));
			} else {
				setValid((prev) => ({
					...prev,
					[TY.COMPANIES]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			const tempArr = [
				{ RowNumber: '0', Id: '0', Name: 'All Companies' },
				...payload,
			];
			dispatch({ type: TY.COMPANIES, payload: payload });
			dispatch({ type: TY.ACCESS_OPTIONS, payload: tempArr });
			// Auto-select first company as accessible data
			if (payload.length > 0) {
				dispatch({ type: TY.MST_CUST_ID, payload: payload[0] });
				setValid((prev) => ({
					...prev,
					[TY.MST_CUST_ID]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			} else {
				dispatch({ type: TY.MST_CUST_ID, payload: '' });
				setValid((prev) => ({
					...prev,
					[TY.MST_CUST_ID]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			return;

		case TY.EMAIL_WORK:
			const _emailWork = validateEmail(e.target.value);
			if (_emailWork.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.EMAIL_WORK]: {
						isErr: true,
						errMsg: _emailWork.errMsg,
						canNotSave: true,
					},
				}));
			} else {
				setValid((prev) => ({
					...prev,
					[TY.EMAIL_WORK]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			return dispatch({ type: TY.EMAIL_WORK, payload: e.target.value });

		case TY.EMAIL_PERSONAL:
			const _emailPersonal = validateEmail(e.target.value);
			if (_emailPersonal.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.EMAIL_PERSONAL]: {
						isErr: true,
						errMsg: _emailPersonal.errMsg,
						canNotSave: true,
					},
				}));
			} else {
				setValid((prev) => ({
					...prev,
					[TY.EMAIL_PERSONAL]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			return dispatch({
				type: TY.EMAIL_PERSONAL,
				payload: e.target.value,
			});

		case TY.EMAIL_OTHER:
			const _emailOther = validateEmail(e.target.value);
			if (_emailOther.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.EMAIL_OTHER]: {
						isErr: true,
						errMsg: _emailOther.errMsg,
						canNotSave: true,
					},
				}));
			} else {
				setValid((prev) => ({
					...prev,
					[TY.EMAIL_OTHER]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			return dispatch({ type: TY.EMAIL_OTHER, payload: e.target.value });

		case TY.CONTACT_TYPES:
			if (payload.length === 0) {
				setValid((prev) => ({
					...prev,
					[TY.CONTACT_TYPES]: {
						isErr: true,
						errMsg: USER_CONTACTTYPES_ERR_MSG_EMPTY,
						canNotSave: true,
					},
				}));
			} else {
				setValid((prev) => ({
					...prev,
					[TY.CONTACT_TYPES]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			return dispatch({ type: TY.CONTACT_TYPES, payload: payload });

		case TY.PHONE_WORK:
			return dispatch({ type: TY.PHONE_WORK, payload: payload });

		case TY.PHONE_MOBILE:
			return dispatch({ type: TY.PHONE_MOBILE, payload: payload });

		case TY.PHONE_OTHER:
			return dispatch({ type: TY.PHONE_OTHER, payload: payload });

		case TY.NOTE_RESET:
			return dispatch({ type: TY.NOTE_RESET });

		case TY.UNIT:
			if (addressType === TY.ADDRESS_WORK) {
				return dispatch({
					type: TY.ADDRESS_WORK_UNIT,
					payload: e.target.value,
				});
			} else if (addressType === TY.ADDRESS_HOME) {
				return dispatch({
					type: TY.ADDRESS_HOME_UNIT,
					payload: e.target.value,
				});
			} else if (addressType === TY.ADDRESS_OTHER) {
				return dispatch({
					type: TY.ADDRESS_OTHER_UNIT,
					payload: e.target.value,
				});
			}
			return;

		case TY.U_NAME:
			const _uname = validateUsername(e.target.value);
			if (_uname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.U_NAME]: {
						isErr: true,
						errMsg: _uname.errMsg,
						canNotSave: true,
					},
				}));
			} else if (!_uname.isErr && user[TY.U_NAME] === '') {
				setValid((prev) => ({
					...prev,
					[TY.U_NAME]: { isErr: false, errMsg: '', canNotSave: true },
				}));
			} else if (!_uname.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.U_NAME]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			return dispatch({ type: TY.U_NAME, payload: e.target.value });

		case TY.PWD:
			const _pwd = validatePwd(e.target.value);
			if (_pwd.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.PWD]: {
						isErr: true,
						errMsg: _pwd.errMsg,
						canNotSave: true,
					},
				}));
			} else if (!_pwd.isErr && user[TY.PWD] === '') {
				setValid((prev) => ({
					...prev,
					[TY.PWD]: { isErr: false, errMsg: '', canNotSave: false },
				}));
			} else if (!_pwd.isErr) {
				setValid((prev) => ({
					...prev,
					[TY.PWD]: { isErr: false, errMsg: '', canNotSave: false },
				}));
			}
			setValid((prev) => ({
				...prev,
				[TY.CONFIRM_PWD]: {
					isErr: user[TY.CONFIRM_PWD] !== e.target.value,
					errMsg: USER_CONFIRMPWD_ERR_MSG_MATCH,
					canNotSave: user[TY.CONFIRM_PWD] !== e.target.value,
				},
			}));
			return dispatch({ type: TY.PWD, payload: e.target.value });

		case TY.CONFIRM_PWD:
			const _confirmPwd = user[TY.PWD] === e.target.value;
			if (!_confirmPwd) {
				setValid((prev) => ({
					...prev,
					[TY.CONFIRM_PWD]: {
						isErr: true,
						errMsg: USER_CONFIRMPWD_ERR_MSG_MATCH,
						canNotSave: true,
					},
				}));
			} else if (user[TY.CONFIRM_PWD] === '') {
				setValid((prev) => ({
					...prev,
					[TY.CONFIRM_PWD]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			} else if (_confirmPwd) {
				setValid((prev) => ({
					...prev,
					[TY.CONFIRM_PWD]: {
						isErr: false,
						errMsg: '',
						canNotSave: false,
					},
				}));
			}
			return dispatch({ type: TY.CONFIRM_PWD, payload: e.target.value });

		case TY.IS_ENABLED:
			return dispatch({ type: TY.IS_ENABLED, payload: e.target.checked });

		case TY.MST_CUST_ID:
			if (payload === null) {
				setValid((prev) => ({
					...prev,
					[TY.MST_CUST_ID]: {
						isErr: true,
						errMsg: USER_CUSTOMERS_ERR_MSG_EMPTY,
						canNotSave: true,
					},
				}));
			} else {
				setValid((prev) => ({
					...prev,
					[TY.MST_CUST_ID]: {
						isErr: false,
						errMsg: USER_CUSTOMERS_ERR_MSG_EMPTY,
						canNotSave: false,
					},
				}));
			}
			return dispatch({ type: TY.MST_CUST_ID, payload: payload });

		case TY.ROLES:
			let roleGroups = payload;
			if (roleGroups.length === 0) {
				setValid((prev) => ({
					...prev,
					[TY.ROLES]: {
						isErr: true,
						errMsg: USER_ROLES_ERR_MSG_EMPTY,
						canNotSave: true,
					},
				}));
			} else {
				setValid((prev) => ({
					...prev,
					[TY.ROLES]: { isErr: false, errMsg: '', canNotSave: false },
				}));
			}
			return dispatch({ type: TY.ROLES, payload: payload });

		case TY.POST_LOGIN_APP_ID:
			return dispatch({
				type: TY.POST_LOGIN_APP_ID,
				payload: e.target.value,
			});

		case TY.RESET:
			dispatch({ type: TY.RESET, payload: initUser });
			setValid(initValid);
			handleMode(true);
			return;

		default:
			return dispatch({ type: e.target.name, payload: e.target.value });
	}
}

export default handleUser;
